import T from 'prop-types';

const countryOrStateRow = T.shape({
  name: T.string,
  code: T.string,
});

const countryDataProp = T.arrayOf(countryOrStateRow);
const usStatesDataProp = T.arrayOf(countryOrStateRow);

export const locationDataProp = T.shape({
  countries: countryDataProp,
  usStates: usStatesDataProp,
});

export const formFriendlyData = (data) => {
  return data.map((countryOrState) => {
    return {
      label: countryOrState.name,
      value: countryOrState.code,
    };
  });
};
